// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, bool, func, string } from 'prop-types'
import Coordination from './Coordination'
import Location from './Location'
import MultiSelects from './MultiSelects'
import Path from './Path'
import Sites from './Sites'
import Buttons from './Buttons'

const rowClasses = 'display-flex justify-content-between align-items-start'
const mainColumnClasses = 'flex-1'

const skinnyCol = { width: '12%' }

const Search = props => {
  const {
    customImportHandler,
    highlightRows,
    highlightedRows,
    idRoot,
    sourceForm,
  } = props

  return (
    <div className={'padding-1'}>
      <ul
        className={`${rowClasses} position-relative z-index-2`}>
        <li className={mainColumnClasses}>
          <Sites idRoot={idRoot} />
        </li>
        <li className={mainColumnClasses}>
          <MultiSelects
            idRoot={idRoot}
            sourceForm={sourceForm} />
        </li>
        <li
          className={'database-search-actions position-relative'}
          style={skinnyCol}>
          <Buttons
            customImportHandler={customImportHandler}
            highlightRows={highlightRows}
            highlightedRows={highlightedRows}
            idRoot={idRoot}
            sourceForm={sourceForm} />
        </li>
      </ul>
      <ul
        key={'bottom-row'}
        className={`${rowClasses} margin-top-1 padding-top-1`}>
        <li className={mainColumnClasses}>
          <Coordination
            idRoot={idRoot} />
        </li>
        <li className={mainColumnClasses}>
          <Path
            idRoot={idRoot}
            sourceForm={sourceForm} />
        </li>
        <li style={skinnyCol}>
          <Location
            idRoot={idRoot}
            sourceForm={sourceForm} />
        </li>
      </ul>
    </div>
  )
}

Search.propTypes = {
  customImportHandler: func.isRequired,
  highlightRows: bool,
  highlightedRows: array.isRequired,
  idRoot: string.isRequired,
  sourceForm: string.isRequired,
}

export default Search
